/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    CODE: 'Codice',
    COUNTERPARTS: 'Contropartite',
    CURRENT: 'Attuale',
    GENERAL_INFORMATION: 'Informazioni generali',
    MANAGER: 'Responsabile',
    PREVIOUS: 'Precedente',
    PRODUCTS: 'Prodotti',
    REMUNERATION: 'Retribuzioni',
    SUPERVISOR: 'Supervisore'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
